module.exports = __webpack_public_path__ + "static/media/Student Registering on JobJump.92bd069d.docx";